export default __webpack_public_path__ + "static/distracted-34107eb78489fcc3a178495d9716147a.svg";